import Text from "components/Text/Text";
import VariableText from "components/VariableText/VariableText";
import { useTranslation } from "modules";

import { noop } from "lodash-es";

interface IPolicyLegalese {
  coveragePremium: string;
  isQuoteAccidentalDeath: boolean;
  policyDocHref?: string;
  soghDocHref?: string;
  onClickPolicyDoc?(): void;
}

function PolicyLegalese(props: IPolicyLegalese) {
  const {
    coveragePremium,
    isQuoteAccidentalDeath,
    onClickPolicyDoc = noop,
    policyDocHref,
    soghDocHref,
  } = props;
  const { t } = useTranslation();

  return (
    <ol>
      <li className="purchase-policy__legalese-item">
        <VariableText
          replacementElement="strong"
          target={/<strong>(.+)<\/strong>/gi}
          text={t(
            "purchase_policy.legalese.bullets.item1.html",
            "Allow Wysh to charge $%<premium>s today, and again each month for the term of your policy. <strong>You may cancel anytime.</strong>",
            { premium: coveragePremium }
          )}
        />
      </li>

      {soghDocHref && (
        <>
          <li className="purchase-policy__legalese-item purchase-policy__legalese-item--sogh">
            <VariableText
              replacementElement="strong"
              target={/<strong>(.+)<\/strong>/gi}
              text={t(
                "purchase_policy.legalese.bullets.item2.html",
                "Accept and electronically sign the <strong>Statement of Good Health</strong>, and all terms and conditions contained therein."
              )}
            />
            <a
              className="purchase-policy__sogh-link link-text"
              href={soghDocHref}
              rel="noreferrer"
              target="_blank">
              <Text
                as="span"
                tag="l4"
                text={t("purchase_policy.document.good_health.cta", "See Statement of Good Health")}
              />
            </a>
          </li>
        </>
      )}

      <li className="purchase-policy__legalese-item">
        <VariableText
          replacementElement="strong"
          target={/<strong>(.+)<\/strong>/gi}
          text={t(
            "purchase_policy.legalese.bullets.item3.html",
            "Accept the <strong>%<product_type>s</strong> and all terms and conditions contained therein.",
            {
              product_type: isQuoteAccidentalDeath
                ? t("general.product_type.ad", "Accidental Death Insurance Policy")
                : t("general.product_type.term", "Individual Term Life Insurance Policy"),
            }
          )}
        />
        <a
          className="purchase-policy__policy-link link-text"
          href={policyDocHref}
          onClick={onClickPolicyDoc}
          rel="noreferrer"
          target="_blank">
          <Text
            as="span"
            tag="l4"
            text={t("purchase_policy.document.policy_packet.cta", "See Policy Packet")}
          />
        </a>
      </li>
    </ol>
  );
}

export default PolicyLegalese;
